import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../Config/Config";

export const fetchBoardData = createAsyncThunk("api/board", async () => {
  const response = await fetch(
    `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-education-boards-list`
  );
  const data = await response.json();
  return data;
});

const boardSlice = createSlice({
  name: "board",
  initialState: {
    boardData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBoardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBoardData.fulfilled, (state, action) => {
        state.loading = false;
        state.boardData = action.payload;
      })
      .addCase(fetchBoardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default boardSlice.reducer;
